import { useRef } from 'react'
import Slider from 'react-slick'
import Review from 'components/Teasers/Review'
import { settings } from './settings'
import styles from './Reviews.module.scss'

export default function Reviews({ section }) {
  const { title, reviews } = section
  const sliderRef = useRef()

  if (!reviews || reviews.length === 0) {
    return null
  }

  return (
    <section className={styles.section} id="arvostelut">
      <div className={`container slick-overflow ${styles.container}`}>
        <h2 className={styles.title}>{title || 'Arvostelut'}</h2>

        <div className={styles.controls}>
          <img
            src="/img/next-icon.svg"
            role="button"
            onClick={() => sliderRef.current.slickPrev()}
            className={styles.prev}
          />
          <img
            src="/img/next-icon.svg"
            role="button"
            onClick={() => sliderRef.current.slickNext()}
            className={styles.next}
          />
        </div>

        <Slider className={styles.wrap} ref={sliderRef} {...settings}>
          {reviews.map((review) => (
            <Review key={review.id} review={review} />
          ))}
        </Slider>
      </div>
    </section>
  )
}
